import { render } from "./lesson.vue?vue&type=template&id=267c4a47"
import script from "./lesson.vue?vue&type=script&lang=js"
export * from "./lesson.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\xiongmao-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__